module.exports = __webpack_public_path__ + "static/media/37.a060cf60.jpg";